import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { sendQuoteCreateQuote } from '@om/redux/actions/easiplusFuneralPlan/quote';
import { toggleQuoteCallMeBack } from '@om/redux/actions/easiplusFuneralPlan/callMeBack';
import { getQuoteSummary } from '@om/redux/selectors/easiplusFuneralPlan/quote';
import { OmQuoteSummaryCard } from '@om/component-library-react';
import OmButton from '../../../components/forms/OmButton';
import { navigateToReplacementPolicy } from '@om/redux/actions/easiplusFuneralPlan/routing';

const QuoteSummaryCard = ({ isSticky, name }) => {
    const dispatch = useDispatch();
    const { quoteSummary } = useSelector(
        createStructuredSelector({
            quoteSummary: getQuoteSummary,
        })
    );

    return (
        <OmQuoteSummaryCard
            canPurchase
            isSticky={isSticky}
            name={name}
            productName="Funeral cover"
            coverCategories={quoteSummary.categories}
            coverCategoryAmounts={quoteSummary.categoryAmounts}
            onBuyNowClicked={() => {
                dispatch(navigateToReplacementPolicy());
                dispatch(sendQuoteCreateQuote());
            }}
        >
              
            <OmButton
                slot="cmb-button"
                size="small"
                type="secondary"
                text="CALL ME BACK"
                onClick={() => dispatch(toggleQuoteCallMeBack())}
            />
       
        </OmQuoteSummaryCard>
        
    );
};

export default QuoteSummaryCard;
